import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref } from "vue"

import { ref, toRaw, onMounted, watch } from 'vue'
import type { SelectProps } from 'ant-design-vue'
import { customerCodeDelectSelect } from '@/api/overseasSales/customerCenter'
import { debounce, cloneDeep } from 'lodash-es'

const __default__ = { name: 'RelationCodeSelect' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: Object
  },
  firstData: {
    type: Array
  },
  label: {
    type: [String, Array]
  },
  cosId: {
    type: String
  },
  requiredCosId: {
    type: Boolean,
    default: true
  },
  stage: {
    type: Array,
    default: () => {
      return [2, 3, 4] // 2.潜在 3签约 4 成交
    }
  },
  disabledData: {
    type: Array,
    default: () => {
      return []
    }
  }
},
  emits: ['update:value', 'change', 'update:label'],
  setup(__props, { emit: __emit }) {

const props = __props
const pageNumber = ref(2)
const data = ref()
const searchTxt = ref()
const emit = __emit
const optionPage = ref<any[]>([])
// 赋值
watch(
  () => props.label,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
    } else if (!v) {
      data.value = undefined
    }
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  const find = optionPage.value.find((item) => item.id === value)
  emit('update:label', find?.arkCode)
  emit('update:value', value)
  emit('change', value)
  // 清除搜索
  if (!value && searchTxt.value) {
    fetchCode('')
  }
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
// const fetchValue = (arkCode: any) => {
//   customerCodeDelectSelect({
//     pageNumber: 1,
//     pageSize: 100,
//     arkCode,
//     cosId: props.cosId
//   }).then((res) => {
//     optionPage.value = [...optionPage.value, ...res.data.items]
//   })
// }
const fetchCode = debounce((txt: string) => {
  searchTxt.value = txt?.trim()
  pageNumber.value = 1
  optionPage.value = []
  fetch()
}, 500)
// 获取公司下拉列表
const fetch = () => {
  customerCodeDelectSelect({
    pageNumber: pageNumber.value,
    pageSize: 100,
    arkCode: searchTxt.value,
    stage: props.stage,
    cosId: props.cosId
  }).then((res) => {
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
onMounted(() => {
  if (props.firstData && props.firstData.length) {
    optionPage.value = cloneDeep(toRaw(props.firstData))
    pageNumber.value = 1
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_CosSelect = _resolveComponent("CosSelect")!

  return (_openBlock(), _createBlock(_component_CosSelect, {
    value: data.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
    style: {"width":"100%"},
    onPopupScroll: popupScroll,
    showSearch: true,
    "filter-option": false,
    onSearch: _unref(fetchCode),
    onChange: change
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPage.value, (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          disabled: __props.disabledData.includes(item.arkCode) && data.value !== item.arkCode ? true : false,
          key: item.id,
          value: item.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.arkCode), 1)
          ]),
          _: 2
        }, 1032, ["disabled", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "onSearch"]))
}
}

})